import React from "react";
import Hero from "../components/Hero";
import Banner from "../components/Banner";
import { Link } from "react-router-dom";
import RoomContainer from "../components/RoomContainer";
// import { RoomContext } from "../context";

const Rooms = () => {
	return (
		<>
			<Hero hero="roomsHero">
				<Banner title="our rooms">
					<Link to="/" className="btn-primary">
						Go to Home
					</Link>
				</Banner>
			</Hero>
			<RoomContainer />
		</>
	);
};

export default Rooms;
